import React from 'react';
import PageHeader from 'components/common/general/layouts/PageHeader';

const ProductClassesHeader = (): JSX.Element => {
  return (
    <PageHeader title="Employee Classes" subtitle="Choose products for the employee classes" subtitleMaxWidth="50rem" />
  );
};

export default ProductClassesHeader;
